<template>
	<div class="company-bussi">
		<border-view>
			<div class="view-search" style="margin-bottom:0px;background:transparent;">
				<FromComm :FromArr="FromArr" />
				<CommonBtngroup class="btngroup" :qhide="false" @select="handSearch('')" @reset="handReset('')" />
			</div>
			<!--金额展示部分-->
			<div class="view-amount">
				<div class="amount-label">
					公司商业销售汇总（不含税）
				</div>
				<div class="amount-value">
					{{dataInfo?dataInfo.TotalString:0}}
				</div>
				<div class="amount-unit">
					单位:GTS
				</div>
			</div>
			<!-- 图表 -->
			<company-business v-if="dataInfo&&dataInfo.summaryReport" :info="dataInfo.summaryReport" />
		</border-view>

		<border-view title="公司商业历史销量">
			<div class="view-search" style="padding-top: 24px;">
				<FromComm :FromArr="FromArr2" />
				<CommonBtngroup class="btngroup" :qhide="false" @select="handSearch('2')" @reset="handReset('2')" />
			</div>
			<div class="view-switch-list">
				<div class="view-switch">
					<div class="switch-item-red" v-for="(item,index) in switchYeItems" :key="index"
						:class="[yearIndex===index?'current-red':'']" @click="switchChange(index,'year')">
						{{item}}
					</div>
				</div>
			</div>
			<!-- 图表 -->
			<company-year v-if="dataInfo2" :info="dataInfo2" :type="yearIndex" />
		</border-view>

		<border-view title="L3公司销量趋势图">
			<div class="view-search" style="padding-top: 24px;">
				<FromComm :FromArr="FromArr3" />
				<CommonBtngroup class="btngroup" :qhide="false" @select="handSearch('3')" @reset="handReset('3')" />
			</div>
			<div class="view-switch-list">
				<div class="view-switch" style="margin-right:48px;">
					<div class="switch-item-red" v-for="(item,index) in switchYeItems" :key="index"
						:class="[l3Index===index?'current-red':'']" @click="switchChange(index,'l3')">
						{{item}}
					</div>
				</div>
				<div class="view-switch">
					<div class="switch-item-blue" v-for="(item,index) in switchSJItems" :key="index"
						:class="[sjIndex===index?'current-blue':'']" @click="switchChange(index,'sj')">
						{{item}}
					</div>
				</div>
			</div>
			<!-- 图表 -->
			<company-trend v-if="dataInfo3&&sjIndex===0" :info="dataInfo3" :type="l3Index" />
			<!-- 图表 -->
			<company-money v-if="dataInfo3&&sjIndex===1" :info="dataInfo3" :type="l3Index" />
		</border-view>
	</div>
</template>

<script>
	import {
		GetHelperLevel1,
		GetSMSReportZylox,
		GetHelperLevel3,
		GetSMSReportZyloxBySales,
		GetSMSReportZyloxTendency
	} from '@/api/newsapi'
	import companyBusiness from './charts/company-business.vue';
	import companyYear from './charts/company-year.vue';
	import companyTrend from './charts/company-trend.vue';
	import companyMoney from './charts/company-money.vue';
	import FromComm from '../../../views/home/components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import borderView from './border-view.vue';

	import {
		FromArr,
		FromArr2
	} from '../FormData/companyBussi';
	export default {
		components: {
			companyBusiness,
			FromComm,
			CommonBtngroup,
			companyYear,
			companyTrend,
			companyMoney,
			borderView
		},
		data() {
			return {
				FromArr: [],
				FromArr2: [],
				FromArr3: [],
				switchYeItems: ['月度', '季度', '年度'],
				yearIndex: 1,
				switchSJItems: ['数量', '金额'],
				sjIndex: 0, //数量金额
				l3Index: 1,
				query: {},
				dataInfo: null,
				query2: {},
				dataInfo2: null,
				query3: {},
				dataInfo3: null,
			}
		},
		created() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArr2 = JSON.parse(JSON.stringify(FromArr2))
			this.FromArr3 = JSON.parse(JSON.stringify(FromArr2))
			this.getHelperLevel1();
			this.getSMSReportZylox();
			this.getHelperLevel3();
			this.getSMSReportZyloxBySales();
			this.getSMSReportZyloxTendency();
		},
		methods: {
			//获取l1数据
			async getHelperLevel1() {
				let {
					code,
					data
				} = await GetHelperLevel1({})
				if (code == 0) {
					/*{
						key: '不限',
						value: '',
					}*/
					this.FromArr[0].options = []
					this.FromArr2[0].options = [{
						key: '不限',
						value: '',
					}]
					this.FromArr3[0].options = [{
						key: '不限',
						value: '',
					}]
					data.map((item, index) => {
						let obj = {
							key: item.value,
							value: item.key
						}
						this.FromArr[0].options.push(obj);
						this.FromArr2[0].options.push(obj);
						this.FromArr3[0].options.push(obj);
					})
				}
			}, //获取l3数据
			async getHelperLevel3() {
				let {
					code,
					data
				} = await GetHelperLevel3({})
				if (code == 0) {
					this.FromArr2[1].options = [];
					this.FromArr3[1].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.value,
							value: item.key
						}
						this.FromArr2[1].options.push(obj);
						this.FromArr3[1].options.push(obj);
					})
				}
			}, // 公司商业
			async getSMSReportZylox() {
				let {
					code,
					data
				} = await GetSMSReportZylox(this.query)
				if (code == 0) {
					this.dataInfo = data;
				}
			}, // 公司商业历年销售 
			async getSMSReportZyloxBySales() {
				let params = {};
				params.ByQuarter = this.yearIndex;
				params = Object.assign({}, params, this.query2);

				let {
					code,
					data
				} = await GetSMSReportZyloxBySales(params);

				if (code == 0) {
					this.dataInfo2 = data.salesAmountReport;
				}
			}, // L3商业销量趋势图
			async getSMSReportZyloxTendency(e = {}) {
				let params = {};
				params.ByQuarter = this.l3Index;
				params = Object.assign({}, params, e, this.query3);

				let {
					code,
					data
				} = await GetSMSReportZyloxTendency(params);

				if (code == 0) {
					this.dataInfo3 = data.tendencyReport;
				}
			},
			handReset(e = '') {
				if (e == '2') {
					this.FromArr2.map((item, index) => {
						item.modelvalue = '';
					})
					this.query2 = {};
					this.getSMSReportZyloxBySales();
				} else if (e == '3') {
					this.FromArr3.map((item, index) => {
						item.modelvalue = '';
					})
					this.query3 = {};
					this.getSMSReportZyloxTendency();
				} else {
					this.FromArr.map((item, index) => {
						item.modelvalue = '';
						item.StartTime = '';
						item.EndTime = '';
					})
					this.query = {};
					this.getSMSReportZylox();
				}
			},
			handSearch(e = '') {
				if (e == '2') {
					this.query2.LEVEL1 = this.FromArr2[0].modelvalue;
					this.query2.LEVEL3 = this.FromArr2[1].modelvalue ? this.FromArr2[1].modelvalue.join(',') : '';
					this.getSMSReportZyloxBySales();
				} else if (e == '3') {
					this.query3.LEVEL1 = this.FromArr3[0].modelvalue;
					this.query3.LEVEL3 = this.FromArr3[1].modelvalue ? this.FromArr3[1].modelvalue.join(',') : '';
					this.getSMSReportZyloxTendency();
				} else {
					this.query.LEVEL1 = this.FromArr[0].modelvalue ? this.FromArr[0].modelvalue.join(',') : '';
					this.query.StartDate = this.FromArr[1].StartTime;
					this.query.EndDate = this.FromArr[1].EndTime;
					this.getSMSReportZylox();
				}
			},

			switchChange(e, k) {
				this[k + 'Index'] = e;
				if (k === 'year') {
					this.getSMSReportZyloxBySales();
				}
				if (k === 'l3') {
					this.getSMSReportZyloxTendency();
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.company-bussi {
		padding-bottom: 200px;

		.view-search {
			height: 88px;
			margin: 16px 0px 16px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom: 1px solid #E5E5E5;

			.search-title {
				font-size: 16px;
				font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
				font-weight: 500;
				color: #1D2129;
				position: absolute;
				top: 16px;
				left: 16px;
			}


			.btngroup {
				float: none;
				//margin-left: 24px;
				margin-top: 0px;
			}
		}


		.view-switch-list {
			display: flex;
			align-items: center;
			justify-content: center;

			.view-switch {
				overflow: hidden;
				display: flex;
				cursor: pointer;

				.switch-item-red {
					width: 80px;
					height: 32px;
					line-height: 32px;
					text-align: center;
					box-sizing: border-box;
					font-size: 14px;
					font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
					font-weight: 400;
					color: #E71D43;
					background: url('../../../../assets/report/btn-red.png') no-repeat;
					background-size: 100% 100%;
					margin: 0px 8px;
				}

				.switch-item-blue {
					width: 80px;
					height: 32px;
					line-height: 32px;
					text-align: center;
					box-sizing: border-box;
					font-size: 14px;
					font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
					font-weight: 400;
					color: #00266D;
					background: url('../../../../assets/report/btn-blue.png') no-repeat;
					background-size: 100% 100%;
					margin: 0px 8px;
				}

				.current-red {
					background: url('../../../../assets/report/btn-red-checked.png') no-repeat;
					background-size: 100% 100%;
					color: #FFFFFF;
				}

				.current-blue {
					background: url('../../../../assets/report/btn-blue-checked.png') no-repeat;
					background-size: 100% 100%;
					color: #FFFFFF;
				}
			}
		}

		.merge {
			min-height: 120px;
			padding-bottom: 22px;
			position: relative;
			margin-bottom: 0px;
			align-items: flex-end;
		}

		.content-view {
			background: #FFFFFF;
			margin-top: 16rpx;
			position: relative;
		}

		.view-amount {
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;
			padding: 12px;


			.amount-label {
				font-size: 16px;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #333333;
			}

			.amount-value {
				font-size: 32px;
				font-family: D-DIN-Bold, D-DIN;
				font-weight: 700;
				line-height: 40px;
				letter-spacing: 5px;
				//text-shadow: 0px 2px 8px rgba(27, 126, 242, 0.32);
				background: linear-gradient(180deg, rgba(27, 126, 242, 0.48) 0%, #1B7EF2 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				margin: 0px 10px;
			}

			.amount-unit {
				font-size: 14px;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #999999;
			}
		}
	}
</style>